// Components & Data Imports
import Footer from '../layout/Footer'
import NewsItem from '../components/NewsItem'
import newsData from '../resources/newsData.json'

// Icons
import { PiNewspaperClippingFill } from 'react-icons/pi'

const News = () => {
  return (
    <>
      <div className='news'>
        <div className='news-bg'></div>
        <div className='news-heading'>
          <PiNewspaperClippingFill className='news-heading-icon' />
          <div className='news-heading-title'>Aktuality</div>
          <div className='news-heading-subtitle'>
            Novinky z táborového světa
          </div>
        </div>
        <div className='news-container'>
          {newsData.map(item => (
            <NewsItem
              key={item.date + item.title}
              date={item.date}
              title={item.title}
              message={item.message}
              links={item.links}
            />
          ))}
        </div>
      </div>
      <Footer />
    </>
  )
}

export default News
